import { getDefaultHeader } from '../../services/serviceAPIHelper';
import { getUserInformation } from '../Login/loginService';


function isValidPassword(password) {
    const passwordValidExp = /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/;

    return passwordValidExp.test(password);
}

/**
   * Validate password rules.
   * Rules:
   *  ^.*              : Start
   *  (?=.{8,})        : Length. Password must have 8 characters 
   *  (?=.*[a-zA-Z])   : Letters. Password must have at least 1 Capital Letter.
   *  (?=.*\d)         : Digits. Password must have at least 1 digit.
   *  .*$              : End
   *
   */
export function validatePassword(newPassword, confirmPassword) {

    const isValid = isValidPassword(newPassword);

    if (!isValid) {
        return {
            failed: true,
            message: 'RECOVER_PASSWORD.PASSWORD_VALIDATION_PATTERN'
        };
    }

    if (newPassword !== confirmPassword) {
        return {
            failed: true,
            message: 'RECOVER_PASSWORD.PASSWORD_VALIDATION_EQUALS'
        };
    }

    return {
        failed: false,
        message: ''
    };
}

export function verifyToken(token) {

    let auxHeaders = getDefaultHeader(false);
    auxHeaders['token'] = token;

    return fetch(process.env.REACT_APP_API_URL + 'user/verifytoken', {
        headers: auxHeaders,
        method: 'GET'
    }).then(response => {
        if (response.status === 200) {
            return response.json();
        } else {
            throw response;
        }
    });
}

export async function adminResetPassword(userName, password) {
    const data = {
        'password': password
    };
    ///v2/backoffice/users
    const url = process.env.REACT_APP_API_URL_V2 + `backoffice/users/${userName}/changepassword`;

    let response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: getDefaultHeader(true)
    });
    if (!response.ok) {
        let body = await response.json();
        //throw new Error(body.message);
        return Promise.reject(body);
    }
    return response.json();
}

export function resetPassword(userName, token, password) {

    let auxHeaders = getDefaultHeader(false);
    auxHeaders['token'] = token;

    const data = {
        'password': password
    };

    const url = process.env.REACT_APP_API_URL + `user/${userName}/resetpassword`;
    return fetch(url, {
        headers: auxHeaders,
        method: 'POST',
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            throw response;
        }
    });
}

export function changePassword(currentPassword, newPassword) {
    const headers = getDefaultHeader(true);
    const user = getUserInformation();

    const data = {
        'password': currentPassword,
        'newPassword': newPassword
    };

    const url = process.env.REACT_APP_API_URL + `user/${user.user_name}/changepassword`;
    return fetch(url, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data)
    }).then(response => {
        if (response.ok) {
            return response.json();
        } else {
            // throw response;
            let pro = new Promise(function (resolve, reject) {
                try {
                    response.json().then(error => {
                        return reject(error);
                    });
                } catch (error) {
                    return reject(error);
                }
            });
            return pro;
        }
    });
}




// WEBPACK FOOTER //
// ./src/components/ChangePassword/ChangePasswordService.js